import {
  acquisitionMetricsActionTypes,
  acquisitionSizeActionTypes
} from './../actions/types';

const initialState = {
  metrics: {},
  size: {}
};

const acquisitionsPage = (state = initialState, action) => {
  switch (action.type) {
    case acquisitionMetricsActionTypes.success:
      return {
        ...state,
        metrics: action.response
      };
    case acquisitionSizeActionTypes.success:
      return {
        ...state,
        size: action.response
      };
    default:
      return state;
  }
};

export default acquisitionsPage;

const getAcquisitionsPage = state => state.acquisitionsPage;
export const getAcquisitionsMetrics = state =>
  getAcquisitionsPage(state).metrics;
export const getAcquisitionsSize = state =>
  getAcquisitionsPage(state).size;




// WEBPACK FOOTER //
// src/reducers/acquisitionsPage.js